import { forwardRef, type InputHTMLAttributes, type ReactNode } from 'react';
import { clsx } from '../clsx';
import styles from './Radio.module.css';

export interface RadioProps extends Omit<InputHTMLAttributes<HTMLInputElement>, 'type'> {
  label: string;
  description?: ReactNode | undefined;
}

/** 14 px radio of the screens: 1.5 px ring, 4 px accent ring when checked. */
export const Radio = forwardRef<HTMLInputElement, RadioProps>(function Radio(
  { label, description, className, ...rest },
  ref,
) {
  return (
    <label className={clsx(styles.label, className)}>
      <input ref={ref} type="radio" className={styles.input} {...rest} />
      <span className={styles.circle} aria-hidden="true" />
      <span className={styles.text}>
        <span>{label}</span>
        {description ? <span className={styles.description}>{description}</span> : null}
      </span>
    </label>
  );
});
